<template>
  <span>
    <svg
      class="loading"
      :width="width"
      :height="width"
      :viewBox="viewBox"
    >
      <g :transform="transform">
        <circle
          class="loading-circle"
          :class="uniqClass"
          :stroke-width="strokeWidth"
          :x="pos"
          :y="pos"
          :r="radius"
        />
      </g>
    </svg>
    <slot name="message" />
  </span>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg'].find(it => it === v)
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      sizes: { sm: 20, md: 40, lg: 80 }
    }
  },
  computed: {
    viewBox () {
      const ratio = 0.825 * this.sizes[this.size]
      return [0, 0, ratio, ratio].join(' ')
    },
    width () {
      return this.sizes[this.size] + 'px'
    },
    transform () {
      const ratio = (0.825 * this.sizes[this.size]) / 2
      return `translate(${ratio}, ${ratio})`
    },
    pos () {
      return -0.125 * this.sizes[this.size]
    },
    radius () {
      return 0.25 * this.sizes[this.size]
    },
    strokeWidth () {
      const ratio = 0.05 * this.sizes[this.size]
      return ratio < 1 ? 1 : ratio
    },
    uniqClass () {
      let classes = `-${this.size}`
      if (this.color !== 'default') classes += ` -${this.color}`
      return classes
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";;

$loading-sizes:( sm: 31, md: 62, lg: 125 );
$loading-color: $neutral-1 !default;

.loading {
  animation: 1.4s circle-rotate linear infinite;
}

.loading-circle {
  stroke: $loading-color;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  fill: none;
  &.-white {
    stroke: white;
  }
  &.-primary-1 {
    stroke: $primary-1;
  }
  &.-primary-2 {
    stroke: $primary-2;
  }
  &.-primary-3 {
    stroke: $primary-3;
  }
  &.-primary-4 {
    stroke: $primary-4;
  }
  &.-primary-5 {
    stroke: $primary-5;
  }
  &.-primary-6 {
    stroke: $primary-6;
  }
  &.-primary-7 {
    stroke: $primary-7;
  }
  &.-primary-8 {
    stroke: $primary-8;
  }
  &.-primary-9 {
    stroke: $primary-9;
  }

  @each $class, $size in $loading-sizes {
    &.-#{$class} {
      stroke-dasharray: $size;
      animation:
        5s circle-#{$class}-dash ease-in-out infinite,
        5s circle-spin ease-in-out infinite;
    }
  }
}

@keyframes circle-rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes circle-spin {
  12.5% { transform: rotate(0deg); }
  25% { transform: rotate(240deg); }
  37.5% { transform: rotate(240deg); }
  50% { transform: rotate(540deg); }
  62.5% { transform: rotate(540deg); }
  75% { transform: rotate(780deg); }
  87.5% { transform: rotate(780deg); }
  100% { transform: rotate(1080deg); }
}

@each $class, $size in $loading-sizes {
  @keyframes circle-#{$class}-dash {
    0% { stroke-dashoffset: $size; }
    12.5% { stroke-dashoffset: calc($size/4); }
    25% { stroke-dashoffset: $size; }
    37.5% { stroke-dashoffset: calc($size/4); }
    50% { stroke-dashoffset: $size; }
    62.5% { stroke-dashoffset: calc($size/4); }
    75% { stroke-dashoffset: $size; }
    87.5% { stroke-dashoffset: calc($size/4); }
    100% { stroke-dashoffset: $size; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/icons/Loading.vue